module.exports = __webpack_public_path__ + "static/img/logo_pass.d228b113.svg";